import React, { FC } from 'react';

import { Version, VersionType } from '@domain/constant/phs/result/versionType';
import classnames from 'classnames/bind';
import styles from './gradeDesc.module.scss';
const cx = classnames.bind(styles);

interface GradeDescProps {
  version: VersionType;
}

const GradeDesc: FC<GradeDescProps> = ({ version }) => {
  const getTextEl = () => {
    if (version === Version.V1) return null;
    return <>(단, 만점자는 항상 최고 등급인 플래티넘을 받을 수 있도록 설계되어 있습니다.)</>;
  };

  return (
    <div className={cx('descArea')}>
      <div className={cx('descWrap')}>
        <em className={cx('title')}>이전 응시보다 높은 점수를 받았는데 등급이 낮아졌나요?</em>
        <span className={cx('desc')}>
          달성 등급은 점수 뿐만 아니라 응시자님과 같은 문제를 풀었던 사람들과 비교하여 계산됩니다. 따라서 점수가
          같더라도 등급의 차이가 있을 수 있습니다.
          <br />
          {getTextEl()}
        </span>
      </div>
    </div>
  );
};

export default GradeDesc;
